import { render, staticRenderFns } from "./EditorRelateid.vue?vue&type=template&id=1772bb86&scoped=true&"
import script from "./EditorRelateid.vue?vue&type=script&lang=js&"
export * from "./EditorRelateid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772bb86",
  null
  
)

export default component.exports